import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { useState } from "react";

import Accordion from "../../../../../../ui library/components/accordions/Accordion";
import HNSColors from "../../../../../../ui library/HNSColors";

import CaseAccordionDetail from "./caseAccordion/CaseAccordionDetail";
import CaseAccordionSummary from "./caseAccordion/CaseAccordionSummary";

export default function DataEntryCases({ label, data }) {
  const [expandedAccordions, setExpandedAccordions] = useState([0]);
  const icons = {
    expandIcon: <KeyboardArrowDown className="text-3xl text-blue-700" />,
    shrinkIcon: <KeyboardArrowUp className="text-3xl text-blue-700" />,
  };

  return (
    <div>
      <div className="w-full">
        <Typography className="pb-4 pt-2 text-xl font-bold">{label}</Typography>
        {data.map((provider) =>
          provider?.cases.map((item, index) => (
            <div className="border-t-2 py-4" style={{ borderColor: HNSColors.primary[900] }}>
              <Accordion
                accordionItem={{
                  summaryClasses: `bg-white w-full px-4`,
                  expandedAccordions,
                  setExpandedAccordions,
                  data: item,
                  index: index,
                }}
                icons={icons}
                summaryContent={CaseAccordionSummary}
                expandedContent={<CaseAccordionDetail />}
                index={index}
                expandOnIconClickOnly={false}
                totalExpandedAccordions={{
                  expandedAccordions,
                  setExpandedAccordions,
                }}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
